import { useEffect, useState } from "react";
import { getBookingsByCartID } from "../../../../actions/admin/booking";

const BookingCancellation = ({ booking }) => {
  const [bookingsByCart, setBookingsByCart] = useState([]);

  useEffect(() => {
    const fetchBookingsByCart = async () => {
      if (!booking?.cartID) return;
      const cartBookings = await getBookingsByCartID(booking.cartID);
      if (Array.isArray(cartBookings)) {
        setBookingsByCart(cartBookings);
      }
    };

    fetchBookingsByCart();
  }, [booking?.cartID]);

  const cancelledChargeRows = (Array.isArray(bookingsByCart) && bookingsByCart.length > 0 ? bookingsByCart : [booking])
    .filter((item) => ["CHARGED", "ADDED_TO_MONTHLY_TOTAL"].includes(String(item?.paymentStatus || "").toUpperCase()));
  const totalChargedAmount = cancelledChargeRows.reduce((sum, item) => sum + Number(item?.totalPrice || 0), 0);
  const cancellationFeeAmount = Number(
    booking?.requestChangeBooking?.totalCancellationFee ||
    booking?.totalCancellationFee ||
    booking?.requestChangeBooking?.cancellationFee ||
    booking?.cancellationFee ||
    0
  );
  const refundAmount = Number(
    booking?.requestChangeBooking?.refundAmount ||
    booking?.refundAmount ||
    Math.max(totalChargedAmount - cancellationFeeAmount, 0)
  );
  const cancellationRate =
    booking?.requestChangeBooking?.cancellationDesc?.en ||
    booking?.cancellationDesc?.en ||
    booking?.requestChangeBooking?.cancellationDesc?.jp ||
    booking?.cancellationDesc?.jp ||
    "-";

  return (
    <section className="tw:mb-6 tw:flex tw:flex-col tw:gap-4">
      <div className="tw:inline-grid tw:grid-cols-[max-content] tw:grid-rows-[max-content] tw:place-items-start">
        <div className="tw:col-1 tw:row-1 tw:mt-[13px] tw:h-[9px] tw:w-[156px] tw:rounded-[2px] tw:bg-[#F9EDD3]" />
        <div className="tw:col-1 tw:row-1 tw:ml-[1.5px] tw:font-hanken-grotesk tw:text-[16px] tw:font-medium tw:leading-[normal] tw:text-[#282828]">
          Booking Cancellation
        </div>
      </div>

      <div className="tw:w-full tw:rounded-[5px] tw:border tw:border-[#E8E8E8] tw:bg-white tw:px-5 tw:py-6">
        <div className="tw:flex tw:flex-col tw:gap-6">
          <div className="tw:flex tw:flex-col tw:gap-[3px]">
            <div className="tw:font-hanken-grotesk tw:text-[13px] tw:font-normal tw:leading-[18.5px] tw:text-[#8D8D8D]">
              Refund Amount (Booking Fee - Total Cancellation Fee)
            </div>
            <div className="tw:font-hanken-grotesk tw:text-[15px] tw:font-normal tw:leading-[22px] tw:text-[#282828]">
              {`${refundAmount.toLocaleString()} JPY `}
              <span className="tw:text-[13px] tw:leading-[18.5px] tw:text-[#8D8D8D]">
                {`(= ${totalChargedAmount.toLocaleString()} JPY - ${cancellationFeeAmount.toLocaleString()} JPY)`}
              </span>
            </div>
          </div>

          <div className="tw:h-px tw:w-full tw:bg-[#E8E8E8]" />

          <div className="tw:flex tw:flex-col tw:gap-6 tw:md:flex-row">
            <div className="tw:w-full tw:md:w-[200px] tw:flex-shrink-0">
              <div className="tw:font-hanken-grotesk tw:text-[13px] tw:font-normal tw:leading-[18.5px] tw:text-[#8D8D8D]">Cancellation Fee</div>
              <div className="tw:font-hanken-grotesk tw:text-[15px] tw:font-normal tw:leading-[22px] tw:text-[#282828]">{`${cancellationFeeAmount.toLocaleString()} JPY`}</div>
            </div>
            <div className="tw:min-w-0 tw:flex-1">
              <div className="tw:font-hanken-grotesk tw:text-[13px] tw:font-normal tw:leading-[18.5px] tw:text-[#8D8D8D]">Cancellation Rate</div>
              <div className="tw:font-hanken-grotesk tw:text-[15px] tw:font-normal tw:leading-[22px] tw:text-[#282828]">{cancellationRate}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BookingCancellation;
